import React, { useState } from "react";
import { Button } from "../../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import useRetryFetch from "../../../../hooks/useRetryFetch";
import { config } from "../../../../Environment";
import { Info } from "lucide-react";
import { t } from "i18next";

const SaveAndContinueModal = ({
  isDialogOpen,
  setIsDialogOpen,
  processId,
  isUserSignedIn,
  onSave,
  onDiscard,
}) => {
  const [saveLoading, setSaveLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const navigate = useNavigate();
  const retryFetch = useRetryFetch(); // ✅ Hook called at the top level

  async function onSaveEngagement() {
    setSaveLoading(true);
    try {
      onSave();
      // TODO: save engagement
      setIsDialogOpen(false);
    } catch (err) {
      console.error("Unexpected error deleting process:", err);
      alert("An unexpected error occurred. Please try again later.");
    } finally {
      setSaveLoading(false);
    }
  }

  async function onDiscardEngagement() {
    setDeleteLoading(true);
    try {
      onDiscard();
      const response = await retryFetch(
        `${config.API_BASE}/api/processes/remove/${processId}`,
        {
          method: "DELETE",
          credentials: "include",
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Failed to delete press:", errorData);
        return;
      }

      const data = await response.json();
      console.log("Successfully deleted:", data);
    } catch (err) {
      console.error("Unexpected error deleting process:", err);
    } finally {
      setDeleteLoading(false);
      setIsDialogOpen(false);
    }
  }

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t("engagement_exit_without_completion_dialog_title")}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {isUserSignedIn ? (
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground text-center">
                {t("save_engagement_exit_heading")}
              </p>
              <Button
                className="w-full"
                onClick={onSaveEngagement}
                disabled={saveLoading}
              >
                {t("save_engagement_exit_btn_text")}
              </Button>

              <p className="text-sm text-muted-foreground text-center">
                {t("discard_engagement_exit_heading")}
              </p>
              <Button
                className="w-full"
                variant="destructive"
                onClick={onDiscardEngagement}
                disabled={deleteLoading}
              >
                {t("discard_engagement_exit_btn_text")}
              </Button>
            </div>
          ) : (
            <div className="text-center space-y-3">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto">
                <Info className="h-8 w-8 text-yellow-600" />
              </div>
              <div>
                <p className="font-medium mb-1 text-yellow-800">
                  {t("engagement_completed_heading_for_non_logged_in_user")}
                </p>
                <p className="text-sm text-muted-foreground">
                  {t("engagement_completed_description_for_non_logged_in_user")}
                </p>
              </div>
              <div className="space-y-2">
                <Button className="w-full">{t("login")}</Button>
                <Button variant="outline" className="w-full">
                  {t("register_new_user")}
                </Button>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SaveAndContinueModal;
